import StGeorgeLogo from '../assets/logo/stgeorge/modern-logo-header.png';
import { createPaletteColourVariations, createTheme } from './theme';
import { ITheme, IThemeColourPalette } from './interfaces';

export const stGeorgeLightPalette: IThemeColourPalette = {
  primary: {
    first: '#e30000', // @brand-primary
    second: '#e30000',
    text: '#004833' // @text-color
  },
  secondary: {
    first: '#78be20', // @shephered-header-color
    second: '#78be20',
    third: '#78be20'
  },
  neutral: {
    black: '#000', // same as CMC
    gray: '#ECEFF0', // same as CMC
    white: '#fff' // same as CMC
  },
  alerts: {
    success: '#54FABB', // same as CMC
    pending: '#FFC405', // same as CMC
    alert: '#EE2F53' // same as CMC
  },
  // Temporary, until UX reviews the colors
  trading: {
    up: '#28BE24',
    down: '#FF0101',
    buy: '#18A0FB',
    sell: '#FFC405'
  }
};

export const stgeorgeDarkPalette: IThemeColourPalette = JSON.parse(JSON.stringify(stGeorgeLightPalette));

stgeorgeDarkPalette.primary.first = '#e30000';
stgeorgeDarkPalette.primary.text = '#fff';
stgeorgeDarkPalette.neutral.black = '#fff';
stgeorgeDarkPalette.neutral.white = '#000';

export const themeStGeorgeLight: ITheme = createTheme('stgeorge.light', stGeorgeLightPalette, { normal: StGeorgeLogo, inverted: StGeorgeLogo });
export const themeStGeorgeDark: ITheme = createTheme('stgeorge.dark', stgeorgeDarkPalette, { normal: StGeorgeLogo, inverted: StGeorgeLogo });

// for storybook mdx
export const lightPalette = createPaletteColourVariations(stGeorgeLightPalette, stGeorgeLightPalette.neutral.white);
export const darkPalette = createPaletteColourVariations(stgeorgeDarkPalette, stgeorgeDarkPalette.neutral.white);
